var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CC6E02",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8.25 21.94 2.94-5.99a1.7 1.7 0 0 1 2.976-.163l4.005 6.345c.802 1.272 2.706.974 3.096-.485l4.131-15.428m-5.144 2.616 5.43-3.194 3.136 5.532M9.965 24.559c0 1.447-1.152 2.62-2.572 2.62S4.82 26.007 4.82 24.56s1.152-2.62 2.573-2.62c1.42 0 2.572 1.173 2.572 2.62Z"
})));
export default SvgLineup;